<template>
<m-pageframe
    title="Test Lightbox"
>
<v-container
    fluid
>
    <div
        class="outer_container"
    >

        <div
            class="left_pane"
        >
        
            <m-edit-css
                label="Background Blur"
                v-model="params.background_blur.style"
                :default_value="params.background_blur.default_style"
                v-on:input="onChange"
            />

            <m-edit-css
                label="Lightbox Container"
                v-model="params.container.style"
                :default_value="params.container.default_style"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Banner Text"
                v-model="params.banner_text"
                v-on:input="onChange"
                hint="This text will show when use logo is unchecked or no logo is available"
            />

            <m-edit-text
                label="Logo Image URL"
                v-model="params.logo_image.url"
            />

            <v-checkbox
                label="Use Logo"
                style="margin-top: -15px"
                v-model="params.use_logo"
                v-on:change="onChange"
            />

            <m-edit-css
                label="Logo Image"
                v-model="params.logo_image.style"
                :default_value="params.logo_image.default_style"
                v-on:input="onChange"
            />

            <m-edit-css
                label="Header Background"
                v-model="params.header_background.style"
                :default_value="params.header_background.default_style"
                v-on:input="onChange"
            />

            <m-edit-css
                label="Close Icon"
                v-model="params.close_icon.style"
                :default_value="params.close_icon.default_style"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Line 1"
                v-model="params.line_1"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Line 2"
                v-model="params.line_2"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Line 3"
                v-model="params.line_3"
                v-on:input="onChange"
            />

            <v-select
                label="First Name"
                v-model="params.first_name.mode"
                :items="$rc.enumChoices('styled_field_mode',false)"
                v-on:input="onChange"
            />

            <v-select
                label="Last Name"
                v-model="params.last_name.mode"
                :items="$rc.enumChoices('styled_field_mode',false)"
                v-on:input="onChange"
            />

            <v-select
                label="Birthday"
                v-model="params.birthday.mode"
                :items="$rc.enumChoices('styled_field_mode',false)"
                v-on:input="onChange"
            />

            <v-select
                label="Email Address"
                v-model="params.email_address.mode"
                :items="$rc.enumChoices('styled_field_mode',false)"
                v-on:input="onChange"
            />

            <v-select
                label="Phone Number"
                v-model="params.phone_number.mode"
                :items="$rc.enumChoices('styled_field_mode',false)"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Agreement"
                v-model="params.agreement"
                v-on:input="onChange"
            />

             <m-edit-css
                label="Send Button"
                v-model="params.send_button.style"
                :default_value="params.send_button.default_style"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Send Button Text"
                v-model="params.send_button_text"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Thank You Line 1"
                v-model="params.thank_you_line_1"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Thank You Line 2"
                v-model="params.thank_you_line_2"
                v-on:input="onChange"
            />

            <m-edit-css
                label="Thank You Button"
                v-model="params.thank_you_button.style"
                :default_value="params.thank_you_button.default_style"
                v-on:input="onChange"
            />

            <m-edit-styled-text
                label="Thank You Button Text"
                v-model="params.thank_you_button_text"
                v-on:input="onChange"
            />

            
            
           <v-btn
                v-on:click="onClickShowLightbox"
                style="margin-right: 15px"
           >
                Show Lightbox
           </v-btn>

           <v-btn
                v-on:click="onClickHideLightbox"
           >
                Hide Lightbox
           </v-btn>

           <v-divider
                style="margin-top: 15px; margin-bottom: 15px"
           />

            <div
                style="margin-top: 15px"
            >
                <pre>{{ JSON.stringify(params, null, 2) }}</pre>
            </div>

        </div>

        <iframe
            class="right_pane"
            :src="iframe_src_url"
            ref="lightbox-iframe"
        />
           
    </div>


</v-container>
</m-pageframe>
</template>

<script>
import mEditCss from '../../components/input/m-edit-css.vue';

// LOGO URL: Pur Noire: https://files.redchirp.com/yrvatevqbrbeuxaaaayfdqzqbbqztfww.png
// LOGO URL: Barrel Creek: https://files.redchirp.com/cvctraabvftrufcaytwyyqyruxuzryzt.png

export default {
  components: { mEditCss },

    data() {
        return {
            params: {
                'organization_id': this.$route.params.organization_id,

                'background_blur': {
                    'style': 'background-color: rgba(255,255,255,0.5); backdrop-filter: blur(10px);',
                    'default_style': 'background-color: rgba(255,255,255,0.5); backdrop-filter: blur(10px);',
                },

                'container': {
                    'style': 'max-width: 600px; background: rgba(255,255,255,1); box-shadow: 0px 0px 15px rgba(0, 0, 0, v-bind(box_shadow_alpha)); border-radius: 15px;',
                    'default_style': 'max-width: 600px; background: rgba(255,255,255,1); box-shadow: 0px 0px 15px rgba(0, 0, 0, v-bind(box_shadow_alpha)); border-radius: 15px;'
                },

                'use_logo': true,

                'banner_text': {
                    'text': 'Barrel Creek',
                    'style': 'font-family: Roboto, sans-serif; font-size: 36px; text-decoration: underline; color: rgba(255,255,255,1.0); padding: 50px 0px 50px 0px',
                    'default_style': 'font-family: Roboto, sans-serif; font-size: 36px; text-decoration: underline; color: rgba(0,0,0,1.0); padding: 50px 0px 50px 0px',
                },

                'logo_image': {
                    'url': 'https://files.redchirp.com/cvctraabvftrufcaytwyyqyruxuzryzt.png',
                    'style': 'max-height: 150px; max-width: 75%; margin: 0px 0px 0px 0px;',
                    'default_style': 'max-height: 150px; max-width: 75%; margin: 0px 0px 0px 0px;',
                },
                
                'header_background' : {
                    'style' : 'background-color: rgba(64,114,143,1.0);',
                    'default_style': 'background-color: rgba(255,255,255,1.0);'
                },

                'close_icon': {
                    'style' : 'color: rgba(255,255,255,1.0);',
                    'default_style': 'color: rgba(0,0,0,1.0);'
                },

                line_1: {
                    'text': 'Enjoy',
                    'style': 'font-family: Roboto, sans-serif; font-size: 20px; text-decoration: none; color: rgba(0,0,0,1.0);',
                    'default_style': 'font-family: Roboto, sans-serif; font-size: 20px; text-decoration: none; color: rgba(0,0,0,1.0);',
                },

                line_2: {
                    'text': '10% Off',
                    'style': 'font-family: Roboto, sans-serif; font-size: 60px; text-decoration: none; color: rgba(0,0,0,1.0); font-weight: 700;',
                    'default_style': 'font-family: Roboto, sans-serif; font-size: 60px; text-decoration: none; color: rgba(0,0,0,1.0);',
                },

                line_3: {
                    'text': 'When you Signup for Email and Text Messages!',
                    'style': 'font-family: Roboto, sans-serif; font-size: 20px; text-decoration: none; color: rgba(0,0,0,1.0);',
                    'default_style': 'font-family: Roboto, sans-serif; font-size: 20px; text-decoration: none; color: rgba(0,0,0,1.0);',
                },

                first_name: {
                    'mode': 'hidden',
                },

                last_name: {
                    'mode': 'hidden',
                },

                birthday: {
                    'mode': 'required',
                },

                email_address: {
                    'mode': 'required',
                },

                phone_number: {
                    'mode': 'required',
                },

                agreement: {
                    'text': 'By submitting this form, you give Red Rock Realty permission to send email and text messages with info, promotions, and offers to the number you provided, including use of an automated system, even if that number is listed on any do not call list. Consent is not a condition of purchase. Texts are recorded. Message and/or data rates may apply. Use is subject to [Terms]({organization-tcr-terms-url}) with an arbitration clause and a [Privacy Policy]({organization-tcr-privacy-policy-url}).',
                    'default_text': 'By submitting this form, you give Red Rock Realty permission to send email and text messages with info, promotions, and offers to the number you provided, including use of an automated system, even if that number is listed on any do not call list. Consent is not a condition of purchase. Texts are recorded. Message and/or data rates may apply. Use is subject to [Terms]({organization-tcr-terms-url}) with an arbitration clause and a [Privacy Policy]({organization-tcr-privacy-policy-url}).',
                    'style': 'font-size: 12px; text-align: justify; margin-top: 25px; color: rgba(0,0,0,0.5)',
                    'default_style': 'font-size: 12px; text-align: justify; margin-top: 25px; color: rgba(0,0,0,0.5)',
                },

                send_button: {
                    'style': 'padding: 10px 0px 10px 0px; background-color: rgba(64,114,143,1.0); border-radius: 3px; width: 100%;',
                    'default_style': 'padding: 10px 0px 10px 0px; background-color: rgba(64,114,143,1.0); border-radius: 3px; width: 100%;',
                },

                send_button_text: {
                    'text': 'Agree and Send',
                    'style': 'font-family: Roboto, sans-serif; font-size: 14px; text-decoration: none; color: rgba(255,255,255,1.0);',
                    'default_style': 'font-family: Roboto, sans-serif; font-size: 14px; text-decoration: none; color: rgba(255,255,255,1.0);',
                },

                thank_you_line_1: { 
                    'text': 'We sent you a text!',
                    'style': 'font-family: Roboto, sans-serif; font-size: 20px; font-weight: 700; text-decoration: none; color: rgba(0,0,0,1.0); padding: 45px 0px 45px 0px;',
                    'default_style': 'font-family: Roboto, sans-serif; font-size: 20px; font-weight: 700; text-decoration: none; color: rgba(0,0,0,1.0); padding: 45px 0px 45px 0px;',
                },

                thank_you_line_2: { 
                    'text': 'Reply YES to confirm your subscription',
                    'style': 'font-family: Roboto, sans-serif; font-size: 18px; text-decoration: none; color: rgba(0,0,0,1.0); padding: 15px 0px 55px 0px;',
                    'default_style': 'font-family: Roboto, sans-serif; font-size: 18px; text-decoration: none; color: rgba(0,0,0,1.0); padding: 15px 0px 55px 0px;',
                },

                thank_you_button: {
                    'style': 'padding: 10px 0px 10px 0px; background-color: rgba(64,114,143,1.0); border-radius: 3px; width: 100%;',
                    'default_style': 'padding: 10px 0px 10px 0px; background-color: rgba(64,114,143,1.0); border-radius: 3px; width: 100%;',
                },

                thank_you_button_text: {
                    'text': 'OK',
                    'style': 'font-family: Roboto, sans-serif; font-size: 14px; text-decoration: none; color: rgba(255,255,255,1.0);',
                    'default_style': 'font-family: Roboto, sans-serif; font-size: 14px; text-decoration: none; color: rgba(255,255,255,1.0);',
                },

                api_root: this.$rc.getAPIEndpoint('',false)
            },
        }
    },

    mounted () {
        this.addCustomFontsToParams();
        this.$rc.loadCustomFonts(this.$route.params.organization_id);
    },

    methods: {
        addCustomFontsToParams()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/css/available-font-families',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.params.custom_fonts = data.custom_fonts;

                        this.$forceUpdate();

                        window.setTimeout(
                            () => this.sendMessage('redchirp-load-fonts'),
                            1000
                        )
                        
                    },
            
                'on_error': 'Unable to list font families',
            });
        },

        onClickShowLightbox() 
        {
           this.sendMessage('redchirp-show-lightbox')
        },

        onClickHideLightbox() 
        {
           this.sendMessage('redchirp-hide-lightbox')
        },

        onChange()
        {
            this.sendMessage('redchirp-change-lightbox')
        },

        sendMessage(message_type)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/settings',
            
                'params' : this.params,
            
                'on_success': (data) => {
                        let iframe = this.$refs['lightbox-iframe'];

                        this.params = data;

                        let message =  [message_type, this.params];
                        
                        iframe.contentWindow.postMessage(
                            message, 
                            '*'
                        );
                    },
            
                'on_error': 'Unable to get lightbox settings',
            });

           
        },
    },

    computed: {
        iframe_src_url() {
            if ( this.$rc.getEnvironment() == 'dev' )
                return 'http://localhost:5173/index.html';

            if ( this.$rc.getEnvironment() == 'staging' )
                return 'https://files.redchirp.com/v1/prod/widget/staging-lightbox.html';

            return 'https://files.redchirp.com/v1/prod/widget/lightbox.html';
        }
    },
}
</script>

<style lang="scss" scoped>
.outer_container
{
    display: flex;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 15px;
    right: 15px;
}

.left_pane
{
    flex-grow: 1; 
    overflow-x: hidden; 
    overflow-y: auto;
    padding-right: 15px; 
    padding-bottom: 15px;
    min-width: 50%;
    max-width: 600px;
}

.right_pane
{
    flex-grow: 1; 
   
    overflow-x: hidden; 
    overflow-y: auto;
}


@media only screen and (max-width: 920px)
{
    .right_pane{
        display: none;
    }

    .left_pane {
        max-width: none;
    }


}
</style>